import { useQuery } from 'react-query';
import { useTokenizedApi } from '../useTokenizedApi';
import { usePersonalProfile } from '../entities/usePersonalProfile';

/**
 * **`React hook`** Provides a list of the contracts accessible in the current
 * profile, including all those that the profile’s entity is a counterparty to,
 * and the contracts for all instruments held by the entity. The list includes
 * contracts that can be edited and contracts that can only be viewed.
 *
 * @category Contracts
 */
export function useContracts({
  profileId,
  includeActiveContracts,
  includeDraftContracts,
  includeEndedContracts,
  filterOwnedContracts,
} = {}) {
  const tokenizedApi = useTokenizedApi();

  const personalProfile = usePersonalProfile();
  profileId = profileId || personalProfile?.id;

  return useQuery({
    ...tokenizedApi.contracts.contractsQuery({ profileId }),
    // Since contracts contain editable data (drafts), we want to
    // reload every time the hook’s component mounts
    refetchOnMount: 'always',
    select: ({ contracts }) =>
      tokenizedApi.contracts.filterContracts({
        profileId,
        contracts,
        includeActiveContracts,
        includeDraftContracts,
        includeEndedContracts,
        filterOwnedContracts,
      }),
  });
}
